module.exports = __webpack_public_path__ + "img/gas-admission-schematic-light.d4546088.png";